import { Result } from 'antd';
import cookie from "js-cookie";
import React from 'react';
import ReactDOM from "react-dom";
import IndexPage from './pages';
import Disclaimer from './pages/policies/disclaimer';
import * as serviceWorker from './register-service-worker';
import './styles/index.less';
import { BrowserUtils } from './utilities';
import CAWebform from './pages/ca-webform';
import { UrlConfigs } from './configurations';
import UnsubscribeNotification from './pages/unsubscribe/notification';

const IE_ROOT_CLASSNAME = "ie-brwsr-root";
const rootElement = document.getElementById("ycc-root");

const isIEBrowser = window.navigator.userAgent?.includes("Trident");
if (isIEBrowser) {
    const existingBodyClass = document.body.getAttribute("class");
    const newBodyClass = existingBodyClass ? `${existingBodyClass} ${IE_ROOT_CLASSNAME}` : IE_ROOT_CLASSNAME;
    document.body.setAttribute("class", newBodyClass);
}

const searchParams = new URLSearchParams(window.location.search);
const view = searchParams.get("view");

 if (process.env.NODE_ENV === "development") {
     cookie.set("brandName", "dummy");
     cookie.set("brandId", "dummy");
     cookie.set("appId", "dummy");
     cookie.set("yccUrl", "dummy");
 }

const brandName = cookie.get("brandName");
const brandId = cookie.get("brandId");
const returnUrl = cookie.get("yccUrl");
const applicationId = cookie.get("appId");

let toBeRendered = <Result status={404} title="Not found" subTitle="Sorry, the page you are looking for does not exist." />

if (view === "disclaimer") {
    toBeRendered = <Disclaimer />
} 
else if(window.location.href.includes(UrlConfigs.ROUTES.CA_WEBFORM.url)){
    toBeRendered = <CAWebform />
}
else if(window.location.href.includes(UrlConfigs.ROUTES.UNSUBSCRIBE_NOTIFICATION.url)){
    toBeRendered = <UnsubscribeNotification />
}
else if (returnUrl) {
    if (brandId && brandName && applicationId) {
        toBeRendered = <IndexPage />
    }
    else {
        console.error("Token does not exist in redirect URL.");
        toBeRendered = <Result status={403} title="Unauthorized" subTitle="Sorry, the page you are looking is not authorized." />
    }
}
else {

    console.error("Return URL not exit in redirect URL.");
}

if (!isIEBrowser && BrowserUtils.isValidBrowserForProceed) {
    Promise.all([
        window.caches?.delete("system-config"),
        window.caches?.delete("health"),
        window.caches?.delete("onload"),
        window.caches?.delete("permission"),
        window.caches?.delete("issue-catalog"),
        window.caches?.delete("finapp")
    ]).finally(() => {
        ReactDOM.render(toBeRendered, rootElement);
    })
}
else {
    ReactDOM.render(toBeRendered, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
if (!isIEBrowser && BrowserUtils.isValidBrowserForProceed) {
    serviceWorker.register();
}
